import request from '@/utils/request'

// 获取计划列表
export function getPlanList(params) {
  return request({
    url: '/api/plan/list',
    method: 'get',
    params
  })
}

// 获取计划详情
export function getPlanDetail(planCode) {
  return request({
    url: `/api/plan/${planCode}`,
    method: 'get'
  })
}

// 添加计划
export function addPlan(data) {
  return request({
    url: '/api/plan',
    method: 'post',
    data
  })
}

// 更新计划
export function updatePlan(planCode, data) {
  return request({
    url: `/api/plan/${planCode}`,
    method: 'put',
    data
  })
}

// 删除计划
export function deletePlan(planCodes) {
  return request({
    url: '/api/plan',
    method: 'delete',
    data: { plan_codes: planCodes }
  })
}

// 更新计划状态
export function updatePlanStatus(planCode, status) {
  return request({
    url: `/api/plan/${planCode}/status`,
    method: 'put',
    data: { status }
  })
}

// 获取计划统计数据
export function getPlanStats() {
  return request({
    url: '/api/plan/stats',
    method: 'get'
  })
} 